<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    mounted() {
       
    },
    watch: {
        model(value) {
            console
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                if (this.field.key == 'basicInfo.permPakResidentId') {
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.resident',
                        value: selectedItem.value,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.permPakResident',
                        value: selectedItem.title,
                    })
                    
                }
            }
        },
    }, // End of Component > watch
}
</script>
